import { ReactNode } from 'react';
import classnames from 'classnames';

interface Props {
  border?: boolean;
  center?: boolean;
  shadow?: boolean;
  children: ReactNode;
}

const Navbar = ({
  border = false,
  center = false,
  shadow = false,
  children,
}: Props) => {
  const className = classnames({
    'bg-navbar-background-color': true,
    'text-navbar-text-color': true,
    'py-2.5': true,
    'align-center': center,
    'border-b': border,
    'border-navbar-border-color': border,
    'drop-shadow-md': shadow,
  });

  return <nav className={className}>{children}</nav>;
};

export default Navbar;
